
<img class="ak-img ak-img-url-logo  d-none d-md-block" [src]="urlLogo">
<img class="ak-img ak-img-url-min  d-block d-md-none" [src]="urlLogoMin">